import { lazy } from 'react';

const Profile = lazy(() => import('../pages'));
const UpdatePassword = lazy(() => import('../pages/updatePassword'));

export const ProfileRoutes = [
  {
    path: '',
    element: <Profile />,
  },
  {
    path: 'alterar-senha',
    element: <UpdatePassword />,
  }
];
